import { Component, Input, OnChanges, Output, EventEmitter } from '@angular/core';

import { GlobalCfgFactory } from '@shared/factories/global-cfg/global-cfg.factory';
import { CustomLandingFactory } from '@shared/factories/custom-landing/custom-landing.factory';
import { FieldTypeTextParentService } from '../utils/field-type-text-parent.service';
import { AfTranslateDirective } from '../../../modules/translate/directive/af-translate.directive';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'primeng/tooltip';
import { NgClass } from '@angular/common';
import { UserPermisionsFactory } from '@shared/factories/user-permisions/user-permisions.factory';
import { FieldSequentialHeaderComponent } from "../../field-sequential-header/field-sequential-header.component";

@Component({
  selector: 'field-type-text-sequential',
  templateUrl: './field-type-text-sequential.component.html',
  standalone: true,
  imports: [
    NgClass,
    TooltipModule,
    FormsModule,
    AfTranslateDirective,
    AfTranslatePipe,
    FieldSequentialHeaderComponent
  ]
})
export class FieldTypeTextSequentialComponent implements OnChanges {
  isLanding: boolean = this.customLanding.isLanding();
  skin: string = this.globalCfg.skin;
  permissions: string = this.userPermissions.getTypePermissions();
  fieldTypeText: any = {
    openLaw: false,
    inputText: '',
    titleField: '',
    minHeight:''
  }

  constructor(private globalCfg: GlobalCfgFactory,
    private customLanding: CustomLandingFactory,
    private fieldTypeTextParent: FieldTypeTextParentService,
    private userPermissions: UserPermisionsFactory) {}

  @Input() field : any ={};
  @Input() preSelectItem : any = '';
  @Input() placeholder: string = '';
  @Input() concept: any = {};
  @Output() itemSelected = new EventEmitter();
  @Output() openRelatedInfo = new EventEmitter();


  ngOnChanges(): void {
     this.fieldTypeTextParent.configureChanges(this);
  }

  enterChangeInField(e: any){
    this.fieldTypeTextParent.enterChangeInField(e, this);
  }

  changeInField(){
    this.fieldTypeTextParent.changeInField(this);
  }

  resetInput(){
    this.fieldTypeTextParent.resetInput(this);
  }

  showReference(e: any){
    this.fieldTypeTextParent.showReference(e, this);
  }

  openModalRelatedInfo(fieldRelatedInfo:any, e: any){
    this.fieldTypeTextParent.openModalRelatedInfo(e, fieldRelatedInfo, this);
  }

  openIaAssistance(){
    this.fieldTypeTextParent.openIaAssistance(this);
  }

}

